/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountDetails,
  BankAccount,
  DiscountAgreements,
  FactoringLimit,
  PaymentTerms,
  RequestRetailerContactUpdateRequestBody,
  RetailerBillingStop,
  RetailerDetails,
} from '../models/index';
import {
    AccountDetailsFromJSON,
    AccountDetailsToJSON,
    BankAccountFromJSON,
    BankAccountToJSON,
    DiscountAgreementsFromJSON,
    DiscountAgreementsToJSON,
    FactoringLimitFromJSON,
    FactoringLimitToJSON,
    PaymentTermsFromJSON,
    PaymentTermsToJSON,
    RequestRetailerContactUpdateRequestBodyFromJSON,
    RequestRetailerContactUpdateRequestBodyToJSON,
    RetailerBillingStopFromJSON,
    RetailerBillingStopToJSON,
    RetailerDetailsFromJSON,
    RetailerDetailsToJSON,
} from '../models/index';

export interface UpdateRequestRetailerContactRequest {
    requestRetailerContactUpdateRequestBody: RequestRetailerContactUpdateRequestBody;
}

/**
 * 
 */
export class RetailerResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for deleteRetailerAccount without sending the request
     */
    async deleteRetailerAccountRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailer`;

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteRetailerAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteRetailerAccountRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteRetailerAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteRetailerAccountRaw(initOverrides);
    }

    /**
     * Creates request options for getAccountsOfCurrentRetailer without sending the request
     */
    async getAccountsOfCurrentRetailerRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailer/account`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAccountsOfCurrentRetailerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccountDetails>>> {
        const requestOptions = await this.getAccountsOfCurrentRetailerRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountDetailsFromJSON));
    }

    /**
     */
    async getAccountsOfCurrentRetailer(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccountDetails>> {
        const response = await this.getAccountsOfCurrentRetailerRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getBankAccountOfCurrentRetailer without sending the request
     */
    async getBankAccountOfCurrentRetailerRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailer/bank-account`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getBankAccountOfCurrentRetailerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BankAccount>> {
        const requestOptions = await this.getBankAccountOfCurrentRetailerRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BankAccountFromJSON(jsonValue));
    }

    /**
     */
    async getBankAccountOfCurrentRetailer(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BankAccount> {
        const response = await this.getBankAccountOfCurrentRetailerRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getBillingStopOfCurrentRetailer without sending the request
     */
    async getBillingStopOfCurrentRetailerRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailer/billing-stop`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getBillingStopOfCurrentRetailerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RetailerBillingStop>> {
        const requestOptions = await this.getBillingStopOfCurrentRetailerRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RetailerBillingStopFromJSON(jsonValue));
    }

    /**
     */
    async getBillingStopOfCurrentRetailer(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RetailerBillingStop> {
        const response = await this.getBillingStopOfCurrentRetailerRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCurrentRetailer without sending the request
     */
    async getCurrentRetailerRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailer`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getCurrentRetailerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RetailerDetails>> {
        const requestOptions = await this.getCurrentRetailerRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RetailerDetailsFromJSON(jsonValue));
    }

    /**
     */
    async getCurrentRetailer(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RetailerDetails> {
        const response = await this.getCurrentRetailerRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDiscountAgreementsOfCurrentRetailer without sending the request
     */
    async getDiscountAgreementsOfCurrentRetailerRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailer/discount-agreements`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getDiscountAgreementsOfCurrentRetailerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscountAgreements>> {
        const requestOptions = await this.getDiscountAgreementsOfCurrentRetailerRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscountAgreementsFromJSON(jsonValue));
    }

    /**
     */
    async getDiscountAgreementsOfCurrentRetailer(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscountAgreements> {
        const response = await this.getDiscountAgreementsOfCurrentRetailerRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getFactoringLimitOfCurrentRetailer without sending the request
     */
    async getFactoringLimitOfCurrentRetailerRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailer/factoring-limit`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getFactoringLimitOfCurrentRetailerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FactoringLimit>> {
        const requestOptions = await this.getFactoringLimitOfCurrentRetailerRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FactoringLimitFromJSON(jsonValue));
    }

    /**
     */
    async getFactoringLimitOfCurrentRetailer(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FactoringLimit> {
        const response = await this.getFactoringLimitOfCurrentRetailerRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentTermsOfCurrentRetailer without sending the request
     */
    async getPaymentTermsOfCurrentRetailerRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailer/payment-terms`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentTermsOfCurrentRetailerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentTerms>> {
        const requestOptions = await this.getPaymentTermsOfCurrentRetailerRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentTermsFromJSON(jsonValue));
    }

    /**
     */
    async getPaymentTermsOfCurrentRetailer(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentTerms> {
        const response = await this.getPaymentTermsOfCurrentRetailerRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateRequestRetailerContact without sending the request
     */
    async updateRequestRetailerContactRequestOpts(requestParameters: UpdateRequestRetailerContactRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['requestRetailerContactUpdateRequestBody'] == null) {
            throw new runtime.RequiredError(
                'requestRetailerContactUpdateRequestBody',
                'Required parameter "requestRetailerContactUpdateRequestBody" was null or undefined when calling updateRequestRetailerContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/retailer/requestRetailerContactUpdate`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RequestRetailerContactUpdateRequestBodyToJSON(requestParameters['requestRetailerContactUpdateRequestBody']),
        };
    }

    /**
     */
    async updateRequestRetailerContactRaw(requestParameters: UpdateRequestRetailerContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateRequestRetailerContactRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateRequestRetailerContact(requestParameters: UpdateRequestRetailerContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateRequestRetailerContactRaw(requestParameters, initOverrides);
    }

}
